
<div class="inline-flex">
  <!-- prevent default is necessary because otherwise these buttons will force submit forms  -->
  <button
    ref="minusButton"
    class="counter"
    :disabled="disableMinus"
    cursor="disabled"
    :aria-label="`Decrease ${label} by ${factor}`"
    aria-describedby="counter-label"
    @click.prevent="handleDecrease"
  >
    <subtract-outline-icon :color="minusColor" :class="disableMinusCursor" :width="40" :height="40" />
  </button>

  <h3 id="counter-label" class="select-none px-12 my-auto" aria-live="assertive">
    <!-- @slot Default slot for counter content. Do not name this slot, it will break Rate. -->
    <slot :count="count" :label="label">
      <span class="font-medium text-m2"> {{ count }} </span>
      <span class="text-grey-text-subdued"> {{ label }} </span>
    </slot>
  </h3>
  <button
    ref="addButton"
    class="counter"
    :disabled="disableAdd"
    :aria-label="`Increase ${label} by ${factor}`"
    aria-describedby="counter-label"
    @click.prevent="handleIncrease"
  >
    <add-outline-icon :color="addColor" :class="disableAddCursor" :width="40" :height="40" />
  </button>
</div>
